<template>
  <div class="sdk-display">
    <sub-menu :activeNum="3"></sub-menu>
    <div class="business-title">
      <button class="addapp" @click="openCreateSdk" v-if="loaded && sdkList.length > 0">
        <span class="icon-plus"></span>
        <span class="text">申请离线SDK</span>
      </button>
      <button class="addapp pswadd" @click="openAddDialog" v-if="loaded && sdkList.length > 0">
        <span class="icon-plus"></span>
        <span class="text">通过密码添加</span>
      </button>
    </div>
    <div v-if="loaded && sdkList.length > 0">
      <div class="app-sdk" v-for="(sdkItem, sdkIndex) in sdkList" :key="sdkIndex">
        <div class="table-header">
          <div class="border" :class="{'border-test': applyStatusHelper.common.calculateTitleStyle(sdkItem.applytype == sdkApplyKeyType.TEST)}"></div>
          <div class="table-header-line1">
            <div class="sdk-name" :title="sdkItem.sdktypeAdd">{{sdkItem.sdktypeAdd}}</div>
            <span class="status"
              :class="[applyStatusHelper.common.calculateTitleStyle(sdkItem.applytype == sdkApplyKeyType.TEST) ? 'status-test' : 'status-normal']"></span>
            <div class="sdk-edit-btn-group"
              v-if="!applyStatusHelper.common.containStatus(sdkItem.status, [SdkStatusKey.VERIFYING, SdkStatusKey.FORMAL_VERIFYING])" >
              <button
                class="g-btn-view renewal-apply-btn"
                @click="handleApplyRenewalSdk(sdkItem)"
                v-if="applyStatusHelper.common.calculateRenewal(sdkItem.status, sdkItem.isrenewal) && sdkItem.applysource === '' && sdkItem.disable !== 'DISABLE'">申请续期</button>
              <button
                v-if="applyStatusHelper.common.calculateProductStyle(sdkItem.status, sdkItem.isrenewal, sdkItem.applytype) && sdkItem.disable !== 'DISABLE'"
                class="g-btn-view formal-apply-btn"
                @click="handleChangeToFormalSdk(sdkItem)">申请正式授权</button>
              <button
                class="delete-sdk-btn"
                v-if="sdkItem.applysource === ''"
                @click="handleDeleteSdk(sdkItem.id)">删除</button>
            </div>
          </div>
          <div class="check" :class="applyStatusHelper.common.calculateStyle(sdkItem.status, ['checking', 'check-success', 'check-fail'])">
            <div class="status-result" v-if="sdkItem.disable !== 'DISABLE'">{{(sdkItem.isrenewal == 1) ? "续期" : ""}}{{applyStatusHelper.common.displayText(sdkItem.status)}}</div>
            <div class="status-result" v-if="sdkItem.disable === 'DISABLE'">{{applyStatusHelper.common.displayText(sdkItem.status)}}</div>
            <div class="review-info">
              <div class="status-item-text" v-if="sdkItem.status == SdkStatusKey.VERIFY_FAIL ||
                applyStatusHelper.common.containStatus(sdkItem.status, [SdkStatusKey.FORMAL_VERIFY_FAIL])">
                <span class="status-item-label">审核失败原因：</span>
                <span class="status-item-reason">{{sdkItem.reason}}</span>
              </div>
              <div class="status-time-appid"
                :class="{'disable-to-use' : sdkItem.expired}">
                <span v-if="(applyStatusHelper.common.containStatus(sdkItem.status, [SdkStatusKey.FORMAL_VERIFY_SUCCESS, SdkStatusKey.FORMAL_AUTH_OVER]) || (applyStatusHelper.common.containStatus(sdkItem.status, [SdkStatusKey.FORMAL_VERIFYING, SdkStatusKey.FORMAL_VERIFY_FAIL]) && sdkItem.isrenewal == 1)) && sdkItem.validbegin">
                  <span>授权时间: {{sdkItem.validbegin}} - {{sdkItem.validend}}</span>
                </span>
                <span v-else>
                  <span v-if="(applyStatusHelper.common.containStatus(sdkItem.status, [SdkStatusKey.VERIFY_SUCCESS, SdkStatusKey.AUTH_OVER]) || (applyStatusHelper.common.containStatus(sdkItem.status, [SdkStatusKey.VERIFYING, SdkStatusKey.VERIFY_FAIL]) && sdkItem.isrenewal == 1)) && sdkItem.validbegin">
                    测试时间: {{sdkItem.validbegin}} - {{sdkItem.validend}}
                  </span>
                </span>
              </div>
              <div class="status-time-appid" :class="{'disable-to-use' : sdkItem.expired}">
                <!-- 新增AppId -->
                <span v-if="sdkItem.appid != ''">App ID: {{sdkItem.appid}}</span>
                <span class="secret appid" v-if="sdkItem.secretkey != ''">SecretKey: {{sdkItem.secretkey}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="sdk-info"
          :class="{'sdk-info-fail': (sdkItem.status == SdkStatusKey.VERIFY_FAIL || sdkItem.status == SdkStatusKey.FORMAL_VERIFY_FAIL) && sdkItem.isrenewal != 1}">
          <div class="sdk-info-row">
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-left">业务类型:</div>
              <div class="sdk-value sdk-value-left sdk-hide-text" :title="sdkItem.busstype">{{sdkItem.busstype}}</div>
            </div>
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-right">申请时间:</div>
              <div class="sdk-value sdk-value-right sdk-hide-text">{{sdkItem.optime}}</div>
            </div>
          </div>
          <div class="sdk-info-row" v-show="sdkItem.bindtype == SdkBindType.APP">
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-left">Bundle ID:</div>
              <div class="sdk-value sdk-value-left sdk-hide-text">
                <div v-if="sdkItem.bundleid" :title="sdkItem.bundleid" class="sdk-app-text">{{sdkItem.bundleid}}</div>
                <div v-else>--</div>
              </div>
            </div>
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-right">Package Name:</div>
              <div class="sdk-value sdk-value-right sdk-hide-text">
                <div v-if="sdkItem.packagename" :title="sdkItem.packagename" class="sdk-app-text">{{sdkItem.packagename}}</div>
                <div v-else>--</div>
              </div>
            </div>
          </div>
          <div class="sdk-info-row" v-if="sdkItem.scope == KeyEnum.JoinWay.EXTERNAL">
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-left">企业名称:</div>
              <div class="sdk-value sdk-value-left sdk-hide-text" :title="sdkItem.extname">{{sdkItem.extname}}</div>
            </div>
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-right">企业网址:</div>
              <div class="sdk-value sdk-value-right sdk-hide-text">
                <div v-if="sdkItem.exturl" :title="sdkItem.exturl">{{sdkItem.exturl}}</div>
                <div v-else>--</div>
              </div>
            </div>
          </div>
          <div class="sdk-info-row">
            <div class="sdk-info-container" v-if="sdkItem.scope == KeyEnum.JoinWay.INTERNAL">
              <div class="sdk-label sdk-label-left">优图接口人邮箱:</div>
              <div class="sdk-value sdk-value-left sdk-hide-text" :title="sdkItem.ytcontact">{{sdkItem.ytcontact}}</div>
            </div>
            <div class="sdk-info-container" v-else>
              <div class="sdk-label sdk-label-left">优图接口人邮箱:</div>
              <div class="sdk-value sdk-value-left sdk-hide-text" :title="sdkItem.ytcontact">{{sdkItem.ytcontact}}</div>
            </div>
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-right">业务接口人及联系方式:</div>
              <div class="sdk-value sdk-value-right sdk-hide-text" :title="sdkItem.peercontact">{{sdkItem.peercontact}}</div>
            </div>
          </div>
          <div class="sdk-info-row" v-if="sdkItem.scope == KeyEnum.JoinWay.EXTERNAL">
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-left">营业执照:</div>
              <div class="sdk-value sdk-value-left">
                <a v-if="sdkItem.extlicense" target="_blank" :href="sdkItem.extlicense" class="business-licence">营业执照</a>
                <a v-else>--</a>
              </div>
            </div>
            <div class="sdk-info-container" v-show="sdkItem.applytype === sdkApplyKeyType.FORMAL">
              <div class="sdk-label sdk-label-right">合同文件:</div>
              <div class="sdk-value sdk-value-right special-height" v-if="sdkItem.applysource === ''">
                <a target="_blank" class="business-licence business-contact"
                  v-for="(url, index) in sdkItem.contract" :key="index"
                  :href="url">合同文件{{index + 1}}</a>
                <a class="cooperation" v-if="sdkItem.contract.length < 1">--</a>
              </div>
              <div class="sdk-value sdk-value-right special-height" v-else>--</div>
            </div>
          </div>
          <div class="sdk-info-row" v-if="sdkItem.scope == KeyEnum.JoinWay.INTERNAL">
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-left">业务所属部门:</div>
              <div class="sdk-value sdk-value-left sdk-hide-text" :title="sdkItem.intdept">{{sdkItem.intdept}}</div>
            </div>
            <div class="sdk-info-container" v-show="sdkItem.applytype === sdkApplyKeyType.FORMAL">
              <div class="sdk-label sdk-label-right">合作备案:</div>
              <div class="sdk-value sdk-value-right special-height">
                <a target="_blank" class="business-licence business-contact"
                  v-for="(url, index) in sdkItem.contract" :key="index"
                  :href="url">合作备案{{index + 1}}</a>
                <a class="cooperation" v-if="sdkItem.contract.length < 1">--</a>
              </div>
            </div>
          </div>
          <div class="sdk-info-row">
            <div class="sdk-info-container">
              <div class="sdk-label sdk-label-left">应用场景:</div>
              <div class="sdk-value desc">
                <description-folder :content="sdkItem.scene" />
              </div>
            </div>
          </div>
        </div>
        <div class="bind-list-container"
          v-if="sdkItem.bindtype == SdkBindType.DEVICE && applyStatusHelper.common.isDeviceVisible(sdkItem.status, sdkItem.isrenewal)">
          <div class="bind-title sdk-label">绑定设备列表:
          </div>
          <div class="device-list-btn-group">
            <!-- <a class="auth-explain" href="https://docs.qq.com/doc/DZGlobmNvRlV2Z1RU" target="_blank">授权说明</a> -->
            <!-- <div class="bind-button" @click="bindDeviceToSdk(sdkItem)" v-if="applyStatusHelper.common.isDeviceEditable(sdkItem.status, sdkItem)">绑定设备</div> -->
            <!-- <div class="bind-button-batch" @click="bindGroupDeviceToSdk(sdkItem)" v-if="applyStatusHelper.common.isDeviceEditable(sdkItem.status, sdkItem)">批量绑定设备</div> -->
            <div class="bind-button" @click="bindDeviceToSdk(sdkItem)" v-if="applyStatusHelper.common.isDeviceEditable(sdkItem.status, sdkItem)">手动绑定</div>
            <a class="bind-device-explain" href="https://docs.qq.com/doc/DZGlobmNvRlV2Z1RU" target="_blank">如何自动绑定</a>
          </div>
          <div class="bind-content">
            <table class="detail-chart">
              <thead>
                <tr>
                  <th>平台</th>
                  <th>设备号</th>
                  <th>设备状态</th>
                  <th>操作</th>
                  <th class="device-remarks">备注</th>
                </tr>
              </thead>
              <tbody class="scrollbar"  v-if="sdkItem.devices && sdkItem.devices.length > 0">
                <tr v-for="(deviceItem, index) in sdkItem.devices.slice((sdkIndexList[sdkIndex] - 1) * pageSize, sdkIndexList[sdkIndex] * pageSize)" :key="index">
                  <td>{{PlatformType[deviceItem.platform]}}</td>
                  <td class="device-number" :title="deviceItem.devno">{{deviceItem.devno}}</td>
                  <td>
                    <span v-if="deviceItem.devno" :class="[ deviceItem.status == DeviceStatus.INACTIVE ?  'activated' : 'created']">
                      <span class="point"></span>
                      {{ deviceItem.status == DeviceStatus.INACTIVE ? `已激活至${deviceItem.end_time}` : '未激活' }}
                    </span>
                  </td>
                  <td>
                    <span class="delete-button" @click="handleDeleteDevice(sdkItem, deviceItem)"
                      v-if="deviceItem.status != DeviceStatus.INACTIVE && deviceItem.devno">
                      删除
                    </span>
                    <div v-if="deviceItem.status == DeviceStatus.INACTIVE && deviceItem.devno">
                      <div class="download-info" @click="downloadCSV(sdkItem, deviceItem)">下载授权</div>
                      <div id="downloadContainer">
                        <div id="downloadForms"></div>
                      </div>
                    </div>
                  </td>
                  <td class="device-remarks">
                    <div class="remarks" v-if="deviceItem.devno">
                      <div class="remarks-content" v-if="deviceItem.remark !== ''" :title="deviceItem.remark">{{deviceItem.remark}}</div>
                      <div class="remarks-content" v-else>暂无</div>
                      <i class="el-icon-edit" @click="showUpdateRemarks(sdkItem.id, sdkItem.appid, deviceItem.devno, deviceItem.remark)"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="platform-table" v-if="sdkItem.deviceStatistics">
              <!-- <div class="platform-column ios">
                <div class="title">iOS</div>
                <div class="content">
                  <div :title="sdkItem.deviceStatistics[PlatformKey.IOS][DeviceAuth.AUTH]">
                    {{sdkItem.deviceStatistics[PlatformKey.IOS][DeviceAuth.AUTH]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.IOS][DeviceAuth.ADD]">
                    {{sdkItem.deviceStatistics[PlatformKey.IOS][DeviceAuth.ADD]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.IOS][DeviceAuth.ACTIVE]">
                    {{sdkItem.deviceStatistics[PlatformKey.IOS][DeviceAuth.ACTIVE]}}
                  </div>
                </div>
              </div> -->
              <div class="platform-column android">
                <div class="title">Android</div>
                <div class="content">
                  <div :title="sdkItem.deviceStatistics[PlatformKey.ANDROID][DeviceAuth.AUTH]">
                    {{sdkItem.deviceStatistics[PlatformKey.ANDROID][DeviceAuth.AUTH]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.ANDROID][DeviceAuth.ADD]">
                    {{sdkItem.deviceStatistics[PlatformKey.ANDROID][DeviceAuth.ADD]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.ANDROID][DeviceAuth.ACTIVE]">
                    {{sdkItem.deviceStatistics[PlatformKey.ANDROID][DeviceAuth.ACTIVE]}}
                  </div>
                </div>
              </div>
              <div class="platform-column x86linux">
                <div class="title">x86 Linux</div>
                <div class="content">
                  <div :title="sdkItem.deviceStatistics[PlatformKey.X86_LINUX][DeviceAuth.AUTH]">
                    {{sdkItem.deviceStatistics[PlatformKey.X86_LINUX][DeviceAuth.AUTH]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.X86_LINUX][DeviceAuth.ADD]">
                    {{sdkItem.deviceStatistics[PlatformKey.X86_LINUX][DeviceAuth.ADD]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.X86_LINUX][DeviceAuth.ACTIVE]">
                    {{sdkItem.deviceStatistics[PlatformKey.X86_LINUX][DeviceAuth.ACTIVE]}}
                  </div>
                </div>
              </div>
              <!-- <div class="platform-column armlinux">
                <div class="title">arm Linux</div>
                <div class="content">
                  <div :title="sdkItem.deviceStatistics[PlatformKey.ARM_LINUX][DeviceAuth.AUTH]">
                    {{sdkItem.deviceStatistics[PlatformKey.ARM_LINUX][DeviceAuth.AUTH]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.ARM_LINUX][DeviceAuth.ADD]">
                    {{sdkItem.deviceStatistics[PlatformKey.ARM_LINUX][DeviceAuth.ADD]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.ARM_LINUX][DeviceAuth.ACTIVE]">
                    {{sdkItem.deviceStatistics[PlatformKey.ARM_LINUX][DeviceAuth.ACTIVE]}}
                  </div>
                </div>
              </div>
              <div class="platform-column windows">
                <div class="title">Windows</div>
                <div class="content">
                  <div :title="sdkItem.deviceStatistics[PlatformKey.WINDOWS][DeviceAuth.AUTH]">
                    {{sdkItem.deviceStatistics[PlatformKey.WINDOWS][DeviceAuth.AUTH]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.WINDOWS][DeviceAuth.ADD]">
                    {{sdkItem.deviceStatistics[PlatformKey.WINDOWS][DeviceAuth.ADD]}}
                  </div>
                  <div :title="sdkItem.deviceStatistics[PlatformKey.WINDOWS][DeviceAuth.ACTIVE]">
                    {{sdkItem.deviceStatistics[PlatformKey.WINDOWS][DeviceAuth.ACTIVE]}}
                  </div>
                </div>
              </div> -->
            </div>
            <div class="platform-table" v-else>
              <!-- <div class="platform-column ios">
                <div class="title">iOS</div>
                <div class="content">
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div> -->
              <div class="platform-column android">
                <div class="title">Android</div>
                <div class="content">
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div>
              <div class="platform-column x86linux">
                <div class="title">x86 Linux</div>
                <div class="content">
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div>
              <!-- <div class="platform-column armlinux">
                <div class="title">arm Linux</div>
                <div class="content">
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div>
              <div class="platform-column windows">
                <div class="title">Windows</div>
                <div class="content">
                  已授权0台<br>
                  已添加0台<br>
                  已激活0台<br>
                </div>
              </div> -->
            </div>
            <el-pagination
              v-if="sdkItem.devices.length > 0"
              layout="prev, pager, next"
              :current-page.sync="sdkIndexList[sdkIndex]"
              :page-size="pageSize"
              :total="sdkItem.devices.length">
            </el-pagination>
          </div>
        </div>
        <div class="mail-receiver">
          <div class="">
            <div class="title-mail">邮件列表:</div>
            <div class="mail-row">
              <div class="receiver-info" :title="sdkItem.mailreceiver">{{sdkItem.mailreceiver ? sdkItem.mailreceiver : '授权到期前会邮件提醒，如有多个接收人请以；分隔'}}</div>
            </div>
            <div class="save-row">
              <el-button @click="showMailReceiverVisible(sdkItem)">修改</el-button>
            </div>
          </div>
        </div>
        <div class="download-button-container" v-if="applyStatusHelper.common.isDeviceEditable(sdkItem.status, sdkItem)">
          <!-- <div class="download-sdk-title">下载SDK:</div>
          <el-select v-model="sdkItem.initDownLoadUrl" placeholder="选择需要下载的SDK" size="small" class="download-select">
            <el-option v-for="(item, index) in sdkItem.sdks" :key="index" :label="item.name" :value="item.url" :disabled="!(item.url.indexOf('unknown') < 0)">
              <span style="float: left">{{ item.name }} </span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{PlatformType[item.platform]}}</span>
            </el-option>
          </el-select>
          <a class="download-sdk-btn" :href="sdkItem.initDownLoadUrl" download @click="downloadSdkRecord(sdkItem, sdkItem.initDownLoadUrl)" target="_blank">下载SDK</a> -->
          <!-- <a class="lic-btn" :href="sdkItem.license" download v-if="sdkItem.bindtype == SdkBindType.APP" target="_blank">下载licence</a> -->
          <a class="lic-btn" v-if="sdkItem.bindtype == SdkBindType.APP" target="_blank" :href="sdkItem.license">下载licence</a>
          <a class="auth-lic-btn" href="https://docs.qq.com/doc/DZFVsR0ZDeUNxekda" target="_blank" v-if="sdkItem.bindtype == SdkBindType.APP">授权说明</a>
        </div>
      </div>
    </div>
    <div class="business-empty" v-if="loaded && sdkList.length === 0">
      <div class="business-empty-icon"></div>
      <div class="business-empty-text">
        您还没有优图离线SDK<br>
        单击“申请离线SDK”按钮，申请优图离线SDK
      </div>
      <div class="empty-button">
        <button class="addapp" @click="$router.transfer(RouteKey.OPEN_SDK_CREATOR)">
          <span class="icon-plus"></span>
          <span class="text">申请离线SDK</span>
        </button>
        <button class="addapp" @click="openAddDialog">
          <span class="icon-plus"></span>
          <span class="text">通过密码添加</span>
        </button>
      </div>
    </div>
    <!-- 手动绑定 -->
    <el-dialog
      title="添加设备"
      :visible.sync="addDeviceVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="cancleBindDeviceForm"
      width="700px">
      <div class="device-button">
        <div
          class="default-button"
          :class="!deviceShow ? '' : 'active-button'"
          @click="handleDevice()">添加设备</div>
        <div
          class="default-button"
          :class="!deviceGroupShow ? '' : 'active-button'"
          @click="handleGroupDevice()">批量添加设备</div>
        <div
          class="default-button"
          :class="!deviceInfoShow ? '' : 'active-button'"
          v-show="showLinux"
          @click="handleDeviceInfo()">上传设备信息</div>
      </div>
      <div class="device-border"></div>
      <!-- 添加设备 -->
      <div class="add-device-form"  v-show="deviceShow">
        <el-form
          :model="addDeviceValidateData"
          :rules="addDeviceRules"
          ref="addDeviceValidateData">
          <el-form-item prop="platform" label="* 选择平台">
            <el-select v-model="addDeviceValidateData.platform" placeholder="请选择平台" key="addDevice">
              <el-option
                v-for="item in PlatformOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="devno" label="* 设备号" key="devno">
            <el-input v-model="addDeviceValidateData.devno" placeholder="请输入设备号(安卓输入序列号，Linux输入mac地址)" :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item prop="remark" label="备注" key="deviceRemarks"
            :rules="[{required: true, message: '备注不能为空', trigger:['change', 'blur']}]">
            <el-input v-model="addDeviceValidateData.remark" placeholder="最多输入32个字符" :maxlength="32"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 批量添加设备 -->
      <div class="add-device-form" v-show="deviceGroupShow">
        <el-form ref="groupAddDeviceValidateData">
          <el-form-item label="* 添加文件" ref="deviceGroupFile">
            <form-item-upload-file
              :twentyM="true"
              :validateFile="validateFile"
              :ErrorName="ErrorName"
              :dialogVisible="groupAddDeviceVisible"
              :NeedConfirm="false"
              :formatCSV="true"
              @validateInfoResult="deviceValidateResult">
            </form-item-upload-file>
          </el-form-item>
          <el-form-item label="示例文件">
            <a class="group-add-device" href="\static\example\sample.csv" download>批量绑定设备示例文件</a>
          </el-form-item>
        </el-form>
      </div>

      <!-- 上传设备信息 -->
      <div class="add-device-form" v-show="deviceInfoShow">
        <el-form
          ref="deviceInfoData"
          :model="deviceInfoData"
          :rules="deviceInfoRules">
          <el-form-item prop="platform" label="* 选择平台">
            <el-select v-model="deviceInfoData.platform" placeholder="请选择平台" key="deviceInfo">
              <el-option
                v-for="item in PlatformOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="* 机器信息文件" ref="deviceInfoFile">
            <form-item-upload-file
              :validateFile="validateInfoFile"
              :twentyM="true"
              :ErrorName="ErrorInfoName"
              :dialogVisible="deviceInfoVisible"
              :NeedConfirm="false"
              :allFormatType="true"
              @validateInfoResult="deviceInfoValidateResult">
            </form-item-upload-file>
            <a href="https://docs.qq.com/doc/DZFBKRU9RTW54cWZt" target="_blank">如何得到机器信息文件</a>
          </el-form-item>
          <el-form-item
            label="备注"
            prop="remark"
            key="remark"
            :rules="[{ required: true, message: '备注不能为空', trigger: ['blur', 'change'] }]">
            <el-input
              v-model="deviceInfoData.remark"
              placeholder="最多输入32个字符"
              :maxlength="32">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmBindDeviceForm()">确 定</el-button>
        <el-button @click="cancleBindDeviceForm()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加合同、合同备案 -->
    <el-dialog
      :title="`请添加${contractTitle}`"
      :visible.sync="contractVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="cancleContractForm"
      width="700px"
      class="contract-dialog">
      <div class="add-device-form add-contract-form">
        <el-form ref="contractForm" :model="renewalValidateForm">
          <el-form-item
            v-if="renewalVisibleFile"
            :label="`* ${contractText}:`"
            ref="contract">
            <form-item-upload-file
              :validateFile="validateFileContract"
              :twentyM="true"
              :ErrorName="ErrorNameContract"
              :dialogVisible="contractVisible"
              :NeedConfirm="false"
              @validateInfoResult="contractValidate">
            </form-item-upload-file>
          </el-form-item>
          <el-form-item
            class="demand-textarea"
            :class="{'show-renewal': renewalVisible}"
            label="续期需求"
            prop="demand"
            :rules="[{ required: true, message: '续期需求不能为空', trigger: ['blur', 'change'] }]">
            <el-input type="textarea" v-model="renewalValidateForm.demand"
              placeholder="如：增加3台设备/延长两个月/增加人脸检测SDK"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="renewalVisible" @click="confirmRenewalAuth()">提交审核</el-button>
        <el-button type="primary" v-else @click="confirmApplyAuth()">提交审核</el-button>
        <el-button @click="cancleContractForm()">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="邮件列表"
      :visible.sync="mailReceiverVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="resetmailReceiverForm"
      width="700px">
      <div class="add-device-form">
        <el-form :model="mailReceiverData" :rules="rulesReceiver" ref="mailReceiverForm">
          <el-form-item prop="receiver" label="授权到期知会人">
            <el-input type="textarea" v-model="mailReceiverData.receiver" placeholder="授权到期前会邮件提醒，如有多个接收人请以;分隔" :maxlength="500"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChangeMailReceiver()">确 定</el-button>
        <el-button @click="resetmailReceiverForm()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改备注 -->
    <el-dialog
      title="修改备注"
      :visible.sync="remarksVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="resetRemarksData"
      width="700px">
      <div class="update-remarks-form">
        <el-form :model="remarksData" ref="remarksRef">
          <el-form-item
            prop="remark"
            label="备注"
            placeholder="最多输入32个字符"
            :rules="[{required: true, validator: validateRemarks}]">
            <el-input v-model="remarksData.remark" :maxlength="32"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarksData()">确定</el-button>
        <el-button @click="resetRemarksData()">取消</el-button>
      </div>
    </el-dialog>
    <!-- 密码添加 -->
    <password-add
      ref="addRef"
      v-model="addShow"
      @query="getAllSdk">
    </password-add>
  </div>
</template>
<script>
import AppDisplayer from './js/OfflineSdkDisplay';
export default AppDisplayer;
</script>
<style lang='less'>
@import "../../../../../styles/btn.less";
@import "./css/common-display.less";
@import "./css/offline-sdk-display.less";
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/OfflineSdkDisplay.vue